<template>
  <Accordion :items="items" :default-open="defaultOpen" columns>
    <template #answer="{ item }">
      <p>{{ item.answer }}</p>

      <i18n-t v-if="item.id === 'howToStart'" keypath="faq.questions.howToStart.guides" tag="p" scope="global">
        <template #newcomers>
          <router-link to="/faq/what-is-it">{{ t('faq.questions.howToStart.newcomersLink') }}</router-link>
        </template>
        <template #cheatsheet>
          <router-link to="/faq/player-cheatsheet">{{ t('faq.questions.howToStart.cheatsheetLink') }}</router-link>
        </template>
      </i18n-t>

      <ul v-else-if="item.id === 'supportDevelopment'" class="u-list">
        <li v-for="key in supportKeys" :key="key">
          {{ t(`faq.questions.supportDevelopment.items.${key}`) }}
        </li>
      </ul>
    </template>
  </Accordion>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Accordion from '@/components/public/Accordion.vue';

const { t } = useI18n();

const props = defineProps({
  /* Which questions this block renders; the view groups them. */
  ids: { type: Array, required: true },
  defaultOpen: { type: Array, default: () => [] },
});

const supportKeys = ['play', 'feedback', 'report', 'invite', 'share'];

const items = computed(() =>
  props.ids.map((id) => ({
    id,
    question: t(`faq.questions.${id}.question`),
    answer: t(`faq.questions.${id}.answer`),
  })),
);
</script>
